import { Box } from "../../box";
import { forwardRef } from "react";
import { cssModule, isNil, mergeProps, normalizeSize, slot } from "../../shared";
import { useResponsiveValue, useStyleProps } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
export const InnerIcon = props => {
  const [styleProps] = useStyleProps("icon");
  const {
    "aria-label": ariaLabel,
    disabled,
    forwardedRef,
    size,
    src,
    ...rest
  } = mergeProps(props, styleProps);
  const sizeValue = useResponsiveValue(size);
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      "aria-hidden": isNil(ariaLabel),
      "aria-label": ariaLabel,
      as: src,
      className: cssModule("o-ui-icon", disabled && "disabled", sizeValue && sizeValue === "inherit" ? "inherit-size" : normalizeSize(sizeValue)),
      // View https://www.scottohara.me/blog/2019/05/22/contextual-images-svgs-and-a11y.html#svgs-that-are-decorative
      focusable: false,
      ref: forwardedRef
    })
  });
};
export const Icon = slot("icon", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerIcon, { ...props,
  forwardedRef: ref
})));
////////
export function createIcon(src) {
  return slot("icon", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerIcon, { ...props,
    forwardedRef: ref,
    src: src
  })));
}